import { Component, OnInit, ViewChild } from '@angular/core';
import { StatisticRecord } from '../../../shared/models/StatisticRecord';
import { MasterRequest, PassRequestDashBoardFilter } from '../../../person-on-board/model/masterrequest.model';
import { Login } from '../../../../app/observation/model/login.model';
import { UnitTreeNode } from '../../../masterscreen/model/unit-tree.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { ObservationService } from '../../../observation/services/observation.service';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { PerformanceConstantsService } from '../../services/performance-constants.service';
import { StatisticFilter } from '../../model/StatisticFilter';
import { PerformanceService } from '../../services/performance.service';
import { SearchText } from 'src/app/observation/model/searchTexts.model';
import { CommonService } from 'src/app/shared/services/common.service';
import moment from 'moment';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import * as XLSX from 'xlsx';


@Component({
  selector: 'ara-statistic-overview',
  templateUrl: './statistic-overview.component.html',
  styleUrls: ['./statistic-overview.component.css']
})
export class StatisticOverviewComponent implements OnInit  {
  @ViewChild('cm') contextMenu: ContextMenu;
  routesFlag: { routeName: string; routeURL: string }[];
  reportRoutes: { routeName: string; routeURL: string }[];
  statisticRecords: StatisticRecord[] = [];
  hideFilter: boolean;
  hideSort: boolean;
  rowCount: number;
  pageSize: number = 1;
  itemPerPage: number = 50;
  pageIndex: number = 0;
  units: any[];
  status: any[] =[];
  loggedInUserJSON: any;
  unitList: any;
  unitTree: UnitTreeNode[];
  userPermissions: UserPermissionParameters;
  selectedUnit: number[] = [];
  selectedStatus: number[] = [];
  selectedContractorIds: number[] = [];

  columnList: any[];
  jsonString: any;
  exportData: any[] = [];
  searchText: string = "";
  searchModified: boolean = false;
  locationList: any[];
  locationDetails: any;
  isCSChecked: boolean = true;
  isStatisticRequestsChecked: boolean;
  statisticRequestForDataResponse: any[] = [];

  noRecordsMsg: string;
  showPagination: boolean;
  selectedPermit: number;
  independentPermissions: any;
  statisticFilter: StatisticFilter;
  searchTexts: SearchText;
  allContractors: any;
  contractorsList: any[];
  selectedDate: Date;
  dateFrom: Date;
  dateTo: Date;
  allUnits: any;
  MonthRange: number[] = [];
  year: number;
  minDateValue: Date;
  maxDateValue: Date;
  selectedRecord:number;
  contextItems: MenuItem[] = [];
  row: HTMLElement;
  unit:number;
  disableExport: boolean = false;


  constructor(private baseService: BaseService, private masterscreenService: MasterscreenService,
    private PDService:PerformanceService, private observationService: ObservationService,private notificationsService: NotificationsService,private commonService: CommonService) {
    this.routesFlag = PerformanceConstantsService.PDNavigation.InnerRoutes;
    this.reportRoutes = PerformanceConstantsService.PDNavigation.ReportRoutes;
    this.statisticRecords = [];
    this.searchTexts = new SearchText();
    this.statisticFilter = new StatisticFilter();
    this.getStatus();
    this.MonthRange = [1,2,3,4,5,6,7,8,9,10,11,12];
    this.year = (new Date()).getFullYear();
  }
  ngOnInit(): void {
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openStatisticRecord()
      }
    ];
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (!this.independentPermissions.PD_Add && !this.independentPermissions.PD_Add_Unit && !this.independentPermissions.PD_Admin && !this.independentPermissions.PD_Admin_Unit && !this.independentPermissions.PD_ContractHolder_Approve) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Contractor Statistics') {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.getUnits();
    this.statisticFilter = new StatisticFilter();
  }

  showContextMenu(record:any) {
    this.selectedRecord = record.statisticId;
    this.unit = record.unitId;
  }
  openStatisticRecord() {
    window.open(
      "/pd/statistic/" + this.selectedRecord+';unitId=' + this.unit,"_blank"
    );
    this.contextMenu.hide();
  }

  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.allUnits = response.Result;
      this.unitList = [];
      this.allUnits.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked:true
        });
        this.selectedUnit.push(unit.UnitId)
      });
    }
     this.setContractorsData();
  }

  setContractorsData() {
    this.searchTexts.UserTypeId = 2;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = 0;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsers.bind(this));
  }
  callbackMethodForGetSearchResultsForUsers(response) {
    if (response.Success) {
      this.allContractors = response.Result;
      this.contractorsList = [];
      this.allContractors.forEach(s => {
        this.contractorsList.push({
          label: s.FullName,
          value: s.UserId,
          checked: true
        });
        this.selectedContractorIds.push(s.UserId);
      }
      );
    }
    this.getStatisticData();
  }

  doneFilter() {
    this.searchModified = true;
    this.monthRange();
    this.getStatisticData();
    this.hideFilter = false;
  }

  getStatisticData() {
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    this.statisticFilter.PageSize = this.itemPerPage;
    this.statisticFilter.SearchText = this.searchText;
    this.statisticFilter.Units = this.selectedUnit;
    this.statisticFilter.Contractors = this.selectedContractorIds;
    this.statisticFilter.StatusId = this.selectedStatus;
    if (!this.statisticFilter.OrderedByColumName) {
      this.statisticFilter.OrderedByColumName = "ContraStatId";
    }
    if (!this.statisticFilter.OrderedBy) {
      this.statisticFilter.OrderedBy = "DESC"
    }
    this.statisticFilter.CurrentPage = this.pageSize;
    if (this.pageSize === 1) {
      this.statisticFilter.PageIndex = 0;
    } else {
      this.statisticFilter.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
    }
    this.statisticFilter.SelectAll = this.isCSChecked;
    this.statisticFilter.Months = this.MonthRange;
    this.statisticFilter.Year = this.year;
    this.statisticFilter.UserId = this.loggedInUserJSON.UserId;
    const filter = JSON.parse(this.baseService.getFilterData('statisticFilter'));
    if (!this.searchModified && filter) {
      this.statisticFilter = filter;
      this.selectedUnit = filter.Units;
      this.isCSChecked = filter.SelectAll;
      this.unitList.forEach(element => {
        element.checked = this.selectedUnit.includes(element) ? true : false;
      });
      this.selectedStatus = filter.StatusId;
      this.status.forEach(element => {
        element.checked = this.selectedStatus.includes(element) ? true : false;
      });
      this.selectedContractorIds = filter.Contractors;
      this.contractorsList.forEach(element => {
        element.checked = this.selectedContractorIds.includes(element) ? true : false;
      });
    }
    else {
      this.baseService.setFilterData('statisticFilter',JSON.stringify(this.statisticFilter));
    }
    this.statisticFilter.UserId = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: this.statisticFilter,
    };
    this.PDService.getStatisticRequests(
      apiRequest,
      this.callbackMethodForGetStatisticData.bind(this)
    );
  }

  callbackMethodForGetStatisticData(response) {
    if (response.Success) {
      this.statisticRecords = [];
       //BOC Pritesh
       if(response.Result.length > 0)
       {
       response.Result.forEach((element,index) => {
         if(element.Status ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
         {
           response.Result.splice(index,1);
         }
       });
       }
        //EOC Pritesh
      this.statisticRequestForDataResponse = response.Result;
      if (this.statisticRequestForDataResponse) {
        this.statisticRequestForDataResponse.forEach((record) => {
              this.statisticRecords.push({
                statisticId: record.StatisticId,
                contractNo: record.ContractNumber,
                submittedBy: record.SubmittedBy,
                contractHolderName: record.ContractHolderName,
                approvedRejectedByName: record.ApprovedRejectedByName,
                reportedMonth: moment(moment.utc(record.ReportedMonth).local()).toDate(),
                status: record.Status,
                unitId: record.UnitId,
                unitName: this.allUnits.find(u => u.UnitId == record.UnitId) ?
                this.allUnits.find(u => u.UnitId == record.UnitId).UnitName : ""
              });
            });
      }
      this.PDService.setAllCheckedStatisticRequestIds(this.statisticRecords);
      if (this.statisticRecords.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }

      if (this.statisticFilter.SelectAll && !this.searchModified) {
        this.selectAllStatisticRequests(this.statisticFilter.SelectAll);
      } else if (this.searchModified) {
        this.statisticFilter.SelectAll = true;
        this.isCSChecked = true;
        this.PDService.setAllCheckedStatisticRequestIds([]);
        this.selectAllStatisticRequests(this.statisticFilter.SelectAll);
      } else {
        if (this.PDService.getAllCheckedStatisticRequestIds()) {
          this.statisticRecords.forEach(record => {
            this.PDService.getAllCheckedStatisticRequestIds().forEach(element => {
              if (element.statisticId === record.statisticId) {
                record.Checked = true;
                return;
              }
            });
          });
        }
      }
    }
    this.baseService.showRootLoader = false;
  }

  setToYear(){
    this.dateTo = this.dateFrom;
    this.minDateValue = this.dateFrom;
    this.maxDateValue = new Date();
  }

  monthRange(){
    this.MonthRange = [];
    if(this.dateFrom && this.dateTo){
      let monthFrom = this.dateFrom.getMonth() + 1;
      let monthTo = this.dateTo.getMonth() + 1;
      this.year = this.dateFrom.getFullYear();

      for (let index = monthFrom; index <= monthTo; index++) {
        this.MonthRange.push(index);
      }
    }else{
      this.MonthRange = [1,2,3,4,5,6,7,8,9,10,11,12];
    }
  }


  resetFilter() {
    this.selectedUnit = [];
    this.unitList.forEach(element => {
      this.selectedUnit.push(element.value)
    });
    this.selectedStatus = [];
    this.status.forEach(element => {
      this.selectedStatus.push(element.value)
    });
    this.selectedContractorIds = [];
    this.contractorsList.forEach(element => {
      this.selectedContractorIds.push(element.value)
    });
    this.dateFrom = null;
    this.dateTo = null;
    this.MonthRange = [1,2,3,4,5,6,7,8,9,10,11,12];
    this.year = (new Date()).getFullYear();
    this.searchModified = true;
    this.getStatisticData();
    this.onClickedOutside();
  }

  searchData() {
    this.statisticFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.getStatisticData();
  }
  clearSearch() {
    this.searchText = "";
    this.searchModified = true;
    this.getStatisticData();
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }

  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  selectAllStatisticRequests(checked) {
    let selectedStatisticRequests: StoredStatisticRequests[] = [];
    this.statisticRecords.forEach((element) => {
      if (checked) {
        element.Checked = true;
        let statisticElem: StoredStatisticRequests = new StoredStatisticRequests();
        statisticElem.statisticId = element.statisticId;
        statisticElem.unitId = element.unitId;
        selectedStatisticRequests = this.PDService.getAllCheckedStatisticRequestIds();
        if (!selectedStatisticRequests) {
          selectedStatisticRequests = [];
        }
       // selectedStatisticRequests.push(statisticElem);
        this.PDService.setAllCheckedStatisticRequestIds(selectedStatisticRequests);
      } else {
        element.Checked = false;
        this.PDService.setAllCheckedStatisticRequestIds([]);
      }
    });
    this.statisticFilter.SelectAll = this.isCSChecked;
    this.baseService.setFilterData(
      "statisticFilter",
      JSON.stringify(this.statisticFilter)
    );
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('statisticFilter'));
    filter.SourceIds = [];
    this.PDService.getAllCheckedStatisticRequestIds().forEach(element => {
      filter.SourceIds.push(element.statisticId);
    });
    const apiRequest = {
      Model: filter
    };
    // Call dummy method to post data
    this.PDService.exportToExcelStatistics(apiRequest, this.callbackMethodForExportToExcelStatisticsData.bind(this));
  }

  callbackMethodForExportToExcelStatisticsData(response) {
    if(response.Success){
      // this.exportData = response.Result;
      // this.columnList = [
      //   { key: "StatisticId", value: "Statistic No" },
      //   { key: "UnitName", value: "Unit" },
      //   { key: "ExactLocation", value: "Location" },
      //   { key: "SubmittedBy", value: "Submitted By" },
      //   { key: "ContractNo", value: "Contract No" },
      //   { key: "ContractHolderName", value: "Contract Holder" },
      //   { key: "Status", value: "Status" },
      //   { key: "SubmittedOn", value: "Submitted On" },
      //   { key: "ReportedMonth", value: "Reported Month" },
      //   { key: "SafetyObsNotReported",value: "No of Safety observations not reported in ARA QHSSE Application"},
      //   { key: "HazardsTourConducetd",value: "No of Hazards Hunt/HSE Tour Conducted"},
      //   { key: "TrainingCompliance",value: "Percentage of HSE training compliance"},
      //   { key: "FitnessToWork",value: "Percentage of fitness to work compliance"},
      //   { key: "EmergencyDrills",value: "Total Emergency Drills Completed"},
      //   { key: "InspectionsAudits",value: "No of Inspections & Audits Completed"},
      //   { key: "VisitsByContractor",value: "No of Management site visit by Contractor Management"},
      //   { key: "Manhours",value: "No of Manhours"},
      //   { key: "PeopleOnBoardContractor",value: "People on board - Contractor"},
      //   { key: "PeopleOnBoardSubContractor",value: "People on board - Sub-contractors"},
      //   { key: "LightVehicles",value: "No of light vehicles"},
      //   { key: "KMLightVehicles",value: "No of Kilometers Driven by light vehicles"},
      //   { key: "HeavyVehicles",value: "No of heavy vehicles"},
      //   { key: "KMHeavyVehicles",value: "No of Kilometers Driven by heavy vehicles"},
      //   { key: "LightBusses",value: "No of light bus"},
      //   { key: "KMLightBusses",value: "No of Kilometers Driven by light bus"},
      //   { key: "HeavyBusses",value: "No of heavy bus"},
      //   { key: "KMHeavyBusses",value: "No of Kilometers Driven by heavy bus"},
      //   { key: "NaturalGasProd",value: "Total Gas Production(m3/M)"},
      //   { key: "FuelGasGenerators",value: "Fuel Gas - Generators(m3/M)"},
      //   { key: "FuelGasTreater",value: "Fuel Gas - Heater Treater(m3/M)"},
      //   { key: "AllGasFlared",value: "All Gas Flared(m3/M)"},
      //   { key: "TotalProducedWater",value: "Total Produced Water(m3/M)"},
      //   { key: "PWReInjected",value: "PW Re-Injected(m3/M)"},
      //   { key: "PWEvaporated",value: "PW Evaporated(m3/M)"},
      //   { key: "WaterAbstracted",value: "Water Abstracted for Water Injection(BBLS/M)"},
      //   { key: "EPFDGS",value: "EPF DGS(Liters/M) "},
      //   { key: "CampDGS",value: "Camp DGS(Liters/M) "},
      //   { key: "ContractorDGS",value: "Contractor DGS(Liters/M)"},
      //   { key: "Vehicle",value: "Vehicle(Liters/M) "},
      //   { key: "StationarySource",value: "Stationary Sources(L) "},
      //   { key: "Generators",value: "Generators(L) "},
      //   { key: "WellsDGS",value: "Wells DGS(Liters/M)"},
      //   { key: "Other",value: "Other(Liters/M)"},
      //   { key: "WaterConsumption",value: "Water Consumption(L)"},
      //   { key: "MainsElectricity",value: "QAM EPF(MWh)"},
      //   { key: "HazardousWasteOily",value: "Hazardous waste(Oily waste)(M3)"},
      //   { key: "HazardousWasteChemical",value: "Hazardous waste(Chemical waste)(M3)"},
      //   { key: "HazardousWasteDrilling",value: "Hazardous waste(Drilling waste)(M3)"},
      //   { key: "HazardousWasteOther",value: "Hazardous waste(Other Waste)(M3)"},
      //   { key: "NonHazardScrap",value: "Non-Hazardous(Scrap metal)(KG)"},
      //   { key: "NonHazardWood",value: "Non-Hazardous(Wood scrap)(KG)"},
      //   { key: "NonHazardPlastic",value: "Non-Hazardous(Plastic Scrap)(KG)"},                                         
      //   { key: "NonHazardDomestic",value: "Non-Hazardous(Domestic / Office)(KG)"},
      //   { key: "NonHazardKitchen",value: "Non-Hazardous(Kitchen)(KG)"},
      //   { key: "SewageWater",value: "Amount Sewage water(Gallon)"},
      //   { key: "OBMDisp",value: "OBM Disp(KG)"},                      
      //   { key: "NumOfConsignmentNote",value: "No of consignment note"}            
      // ];      
      // const parsedResponse: any = FileUtility.convertToCSV(this.exportData,this.columnList);
      // FileUtility.downloadCSV(parsedResponse,'StatisticsReport.csv');
      
    let Heading = [['Statistic No',	'Unit',	'Contract No',	'Submitted By',	'Contract Holder',	'Status',	'Submitted On',	'Reported Month',	'No of Safety observations not reported in ARA QHSSE Application',	'No of Hazards Hunt/HSE Tour Conducted',	'Percentage of HSE training compliance',	'Percentage of fitness to work compliance',	'Total Emergency Drills Completed',	'No of Inspections & Audits Completed',	'No of Management site visit by Contractor Management',	'No of Manhours',	'People on board - Contractor',	'People on board - Sub-contractors',	'No of light vehicles',	'No of Kilometers Driven by light vehicles',	'No of heavy vehicles',	'No of Kilometers Driven by heavy vehicles',	'No of light bus',	'No of Kilometers Driven by light bus',	'No of heavy bus',	'No of Kilometers Driven by heavy bus',	'Total Gas Production(m3)',	'Fuel Gas - Generators(m3)',	'Fuel Gas - Heater Treater(m3)',	'All Gas Flared(m3)',	'Total Produced Water(m3)',	'PW Re-Injected(m3)',	'PW Evaporated(m3)',	'Water Abstracted for Water Injection(BBLS)',	'EPF DGS(L)', 	'Camp DGS(L)', 	'Contractor DGS(L)',	'Stationary Sources(L)', 'Generators(L)','Mains Electicity Use - EPF','Mains Electicity Use - Camp','Mains Electicity Use - Wells','Wells DGS(L)','Other(L)','Vehicle(L)','Water Consumption(m3)','Hazardous waste(Oily waste)(M3)','Hazardous waste(Chemical waste)(M3)','Hazardous waste(Drilling waste)(M3)',	'Hazardous waste(Other Waste)(M3)','Non-Hazardous(Scrap metal)(KG)','Non-Hazardous(Wood scrap)(KG)','Non-Hazardous(Plastic Scrap)(KG)','Non-Hazardous(Domestic / Office)(KG)','Non-Hazardous(Kitchen)(KG)','Amount Sewage water(Gallon)','OBM Disp(M3)','No of consignment note']];  
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, Heading);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, response.Result.ExportToExcelStatisticsData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'StatisticsReport');

    let HeadingLocation = [['Statistic No','Component','Quantity','Location']];
    const wsLocationDet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(wsLocationDet, HeadingLocation);
    XLSX.utils.sheet_add_json(wsLocationDet, response.Result.LocationQtyDetails, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, wsLocationDet, 'LocationReport');
    XLSX.writeFile(wb, 'StatisticsReport.xlsx');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const statisticIds = [];
    this.PDService.getAllCheckedStatisticRequestIds().forEach(element => {
      statisticIds.push({
        ProcessName: 'ContractorStat',
        SourceId: element.statisticId,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (statisticIds.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: statisticIds
        }
      }
      this.PDService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }

  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_statistic_requests.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  downloadPDF(StatId) {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "ContractorStat",
        SourceId: StatId,
        UserId: this.loggedInUserJSON.UserId
      }
    };
    this.PDService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_contractorStat.pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
  }

  selectStatisticRequests(statisticRecord, event) {
    let statisticRecords = this.PDService.getAllCheckedStatisticRequestIds();
    if (event.target.checked) {
      statisticRecords.push({ 'statisticId': statisticRecord.statisticId, 'unitId': statisticRecord.unitId });
      if (statisticRecords.length === this.statisticRequestForDataResponse.length) {
        this.isCSChecked = true;
      }
    } else {
      this.isStatisticRequestsChecked = false;
      this.statisticFilter.SelectAll = this.isStatisticRequestsChecked;

      for (let index = 0; index < statisticRecords.length; index++) {
        const element = statisticRecords[index];
        if (statisticRecord.statisticId === element.statisticId) {
          statisticRecords.splice(index, 1);
          break;
        }
      }

      if (statisticRecords.length !== this.statisticRequestForDataResponse.length) {
        this.isCSChecked = false;
      }

    }
    this.PDService.setAllCheckedStatisticRequestIds(statisticRecords);
    this.baseService.setFilterData('statisticFilter', JSON.stringify(this.statisticFilter));
  }

  getStatus() {
    this.PDService.getStatisticStatus({}, this.callbackMethodForGetStatus.bind(this));
  }
  callbackMethodForGetStatus(response) {
    this.status = [];
    if (response) {
      if (response.Success) {
        response.Result.forEach(element => {
            this.status.push(
            {
              'value': element.StatusId,
              'label': element.StatusName,
              'checked':true
            });
            this.selectedStatus.push(element.StatusId);
        });
      }
    }
  }

  getCurrentDOMElementId(id) {
    this.PDService.setcurrentStatisticPageIndex(id);
    let statistics = this.PDService.getAllCheckedStatisticRequestIds();
    if (!statistics.filter(stat => {
    if (stat.statisticId === id) {
    return stat;
    }
    })) {
    this.statisticRecords.forEach(element => {
    if (element.statisticId === id) {
      statistics.push(element);
    return;
    }
    });
    this.PDService.setAllCheckedStatisticRequestIds(statistics);
    }
  }

  getServerData(event) {
    this.PDService.setcurrentStatisticPageIndex(event);
    if (event === 1) {
      this.statisticFilter.PageIndex = 0;
    } else {
      this.statisticFilter.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.statisticFilter.CurrentPage = event;
    this.pageSize = event;
    this.searchModified = true;
    this.getStatisticData();
  }

  ascId() {
    this.statisticFilter.OrderedByColumName = "ContractNumber";
    this.statisticFilter.OrderedBy = "ASC";
    this.searchModified = true;
    this.getStatisticData();
  }
  descId() {
    this.statisticFilter.OrderedByColumName = "ContraStatId";
    this.statisticFilter.OrderedBy = "DESC";
    this.searchModified = true;
    this.getStatisticData();
  }
  ascSubmittedBy() {
    this.statisticFilter.OrderedByColumName = "ContraStatId";
    this.statisticFilter.OrderedBy = "ASC";
    this.searchModified = true;
    this.getStatisticData();
  }
  descSubmittedBy() {
    this.statisticFilter.OrderedByColumName = "submittedBy";
    this.statisticFilter.OrderedBy = "DESC";
    this.searchModified = true;
    this.getStatisticData();
  }
  ascPtwName() {
    this.statisticFilter.OrderedByColumName = "unitName";
    this.statisticFilter.OrderedBy = "ASC";
    this.searchModified = true;
    this.getStatisticData();
  }
  descPtwName() {
    this.statisticFilter.OrderedByColumName = "unitName";
    this.statisticFilter.OrderedBy = "DESC";
    this.searchModified = true;
    this.getStatisticData();
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
}
export class StoredStatisticRequests {
  statisticId: number;
  unitId: number;
}
